import { atom } from "jotai";

export const isUnityViewerFullScreenAtom = atom(false);
